
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"280","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.065 18.312v4.326H.768v-4.326h4.297zm4.363-4.548v4.548H5.065v-4.548h4.363zm4.485-4.391v4.391H9.428V9.373h4.485zm0 0V5.014h4.347v4.359h-4.347zm4.306-4.359V.532h4.387v4.482H18.22zM26.912 18.312v4.326h-4.298v-4.326h4.297zm4.354-4.548v4.548h-4.354v-4.548h4.354zm4.494-4.391v4.391h-4.494V9.373h4.494zm0 0V5.014h4.297v4.359H35.76zm4.297-4.359V.532h4.395v4.482h-4.395zM61.83.532v8.783h8.725V.532h4.518v22.106h-4.518v-8.775H61.83v8.775H57.31V.532h4.519zM92.05.532v4.482H83.2v4.301h4.584v4.548H83.2v4.482h8.848v4.293H78.83V.532h13.22zM108.428 22.638H95.201V.532h4.297v17.813h8.938l-.008 4.293zM124.496 22.638h-13.244V.532h4.305v17.813h8.939v4.293zM125.748 18.345V5.014h4.518v13.331h-4.518zm4.518-13.331V.532h8.881v4.482h-8.881zm8.881 13.331v4.293h-8.881v-4.293h8.881zm4.347-13.331v13.331h-4.33V5.014h4.33zM150.664 27.063v-4.425h-4.363V18.28h8.652v8.784h-4.289zM167.673 22.638h-4.396v-4.293h-4.543V.532h4.543v17.813h4.396v4.293zm0-22.106h4.264v17.813h4.551v4.293h-4.551v-4.293h-4.264V.532zm8.815 17.813V.532h4.396v17.813h-4.396zM184.338 18.345V5.014h4.518v13.331h-4.518zm4.518-13.331V.532h8.873v4.482h-8.873zm8.873 13.331v4.293h-8.873v-4.293h8.873zm4.33-13.331v13.331h-4.33V5.014h4.33zM218.724 13.863h4.453v8.775h-4.453v-8.775h-8.783v8.775h-4.428V.532h13.211v4.482h4.453v4.301h-4.453V5.014h-8.783v4.301h8.783v4.548zM240.185 22.638h-13.202V.532h4.297v17.813h8.938l-.033 4.293zM256.253 18.345v4.293h-13.235V.532h13.235v4.482h4.289v13.331h-4.297V5.014h-9.004v13.331h9.012zM279.368 13.764h-4.363V.532h4.363v13.232zm0 8.874h-4.363v-4.326h4.363v4.326z","fill":"#5D6882"}})])
          )
        }
      }
    